<template>
   <div
    ref="trigger"
    class="custom-select"
    @click="toggle"
  >

    <div class="selected">
      <h6 v-if="modelValue !== null && modelValue !== undefined && modelValue !== ''">{{ formatValue(modelValue) }} </h6>
      <h6 v-else v-html="menu_icons.lock"></h6>
      <span class="arrow" :class="{ open: isOpen }"></span>
    </div>

    <Teleport to="body">
    <ul
      v-if="isOpen"
      class="options"
      :style="dropdownStyle"
      ref="dropdown"
    >
      <li
        v-for="option in options"
        :key="option"
        @click="select(option)"
        class="option"
      >
        {{ formatValue(option) }}
      </li>
    </ul>
  </Teleport>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, nextTick, onMounted, onBeforeUnmount } from "vue";
import menuIcons from '@/assets/svgs/NotificationMenu.json'

const menu_icons = ref(menuIcons);
const props = defineProps({
  options: Array,
  modelValue: [String, Number]
});

const emit = defineEmits(["update:modelValue"]);

function formatValue(val) {
  if (val === null || val === undefined || val === '') return val;
  const strVal = String(val).trim();
  const num = Number(strVal);
  if (!isNaN(num) && strVal !== '' && !strVal.includes('.')) {
    if (strVal.startsWith('+')) {
      return '+' + num.toFixed(1);
    }
    return num.toFixed(1);
  }
  return val;
}

const isOpen = ref(false);
const trigger = ref(null);
const dropdown = ref(null);
const dropdownStyle = ref({});

function toggle() {
  isOpen.value = !isOpen.value;

  if (isOpen.value) {
    nextTick(() => {
      updatePosition();
    });
  }
}

function select(option) {
  emit("update:modelValue", option);
  isOpen.value = false;
}

function updatePosition() {
  if (!trigger.value) return;

  const rect = trigger.value.getBoundingClientRect();

  dropdownStyle.value = {
    position: "fixed", // 👈 IMPORTANT
    top: rect.bottom + "px",
    left: rect.left + "px",
    width: rect.width + "px",
    zIndex: 20
  };
}
function handleScroll() {
     if (isOpen.value) {
    isOpen.value = false;
  }
  return;
  if (isOpen.value) {
    updatePosition();
  }
}

function handleClickOutside(e) {
  if (!isOpen.value) return;

  const clickedInsideTrigger =
    trigger.value && trigger.value.contains(e.target);

  const clickedInsideDropdown =
    dropdown.value && dropdown.value.contains(e.target);

  if (!clickedInsideTrigger && !clickedInsideDropdown) {
    isOpen.value = false;
  }
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll, true);
  window.addEventListener("resize", handleScroll);
    document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll, true);
  window.removeEventListener("resize", handleScroll);
  document.removeEventListener("click", handleClickOutside);
});
</script>

<style scoped>
.custom-select {
  position: relative;
  /* width: 120px; */
  cursor: pointer;
  user-select: none;
background: var(--odd-background-color);
 z-index: 1000; /* higher than row */
border-radius: 3px;
}

.selected {
  padding: 8px 30px 8px 8px;
  /* border: 1px solid #ccc; */
  text-align: center;
  position: relative;

}

.selected h6 {
    font-size: 13px;
    color: var(--odd-color-text);
    font-weight: 500;
    display: inline-block;
}



.arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  width: 8px;
  height: 8px;
border-right: 1px solid var(--odd-color-text);
    border-bottom: 1px solid var(--odd-color-text);
  transform: translateY(-50%) rotate(45deg);
  transition: transform 0.2s ease;
}

.arrow.open {
  transform: translateY(-50%) rotate(-135deg);
}

.options {
  display: grid;
  position: absolute;
  width: 100%;
  background: var(--odd-background-color);
  /* border: 1px solid #ccc; */
  border-top: none;

  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 1000;
   position: absolute;
  top: 100%;
  left: 0;
  z-index: 9999; /* very important */
      box-shadow: 1px 10px 10px rgba(12, 19, 26, 0.4);

}

.option {
  padding: 8px;
  text-align: left;
  font-size: 13px;
color: var(--odd-color-text);
font-weight: 500;
display: inline-block;
cursor: pointer;

}

.option:hover {
  /* background: #f0f0f0; */
}

.locker-icon {
    fill: var(--odd-color-text);
}

@media screen and (min-width: 320px) and (max-width: 767px) {
  .selected h6 {
    font-size: 11px;
  }

  .option {
    font-size: 11px;
  }

}

</style>
